module.exports = "/static/assets/9d31b6ab445d9d7f66d3e36418d350c4.png";